// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"ea5ffb8d","343":"1d40ab98","365":"792adc92","539":"3ef3c830","787":"c1d39b51","926":"337ab471"}[chunkId] + ".chunk.js";
};